import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { UserGroupService } from '../_services';
import * as UserGroupActions from '../_actions/userGroup';

@Injectable({
  providedIn: 'root',
})
export class UserGroupEffects {
  loadUserGroups$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserGroupActions.loadUserGroups),
      mergeMap(() =>
        this.userGroupService.getUserGroups().pipe(
          map((userGroups) => UserGroupActions.loadUserGroupsSuccess({ userGroups })),
          catchError((error) => of(UserGroupActions.loadUserGroupsFailure({ error })))
        )
      )
    )
  );

  addUserGroup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserGroupActions.addUserGroup),
      mergeMap(({ userGroup }) =>
        this.userGroupService.saveUserGroup(userGroup).pipe(
          map((savedUserGroup) =>
            UserGroupActions.addUserGroupSuccess({ userGroup: savedUserGroup })
          ),
          catchError((error) => of(UserGroupActions.addUserGroupFailure({ error })))
        )
      )
    )
  );

  updateUserGroup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserGroupActions.updateUserGroup),
      mergeMap(({ userGroup }) =>
        this.userGroupService.saveUserGroup(userGroup).pipe(
          map((updatedUserGroup) =>
            UserGroupActions.updateUserGroupSuccess({ userGroup: updatedUserGroup })
          ),
          catchError((error) => of(UserGroupActions.updateUserGroupFailure({ error })))
        )
      )
    )
  );

  deleteUserGroup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserGroupActions.deleteUserGroup),
      mergeMap(({ id }) =>
        this.userGroupService.deleteUserGroup(id).pipe(
          map(() => UserGroupActions.deleteUserGroupSuccess({ id })),
          catchError((error) => of(UserGroupActions.deleteUserGroupFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private userGroupService: UserGroupService
  ) {}
}
